import { useCallback } from 'react';
import { toast } from 'sonner';
import { getTotalRecords, getRows } from '@/utils';
import tagsService from '@/services/setting/tagsService';

const toTagOptions = (rows) =>
    rows.map(tag => ({
        label: tag.name,
        value: tag.name,
        id: tag.id.toString(),
        original: tag,
    }));

const useTagOptions = ({
    defaultPageSize = 20,
    type = null, // 👈 NEW
} = {}) => {
    const loadOptions = useCallback(
        async ({ search = '', page = 1, pageSize = defaultPageSize } = {}) => {
            try {
                const response = await tagsService.getAllTags({
                    page,
                    pageSize,
                    search,
                    type, // 👈 send to backend
                });

                const status =
                    typeof response?.status === 'boolean' ? response.status : true;
                if (!status) return { options: [], hasMore: false };

                let rows = getRows(response);

                // ✅ Fallback (if backend doesn't filter yet)
                if (type) {
                    rows = rows.filter(tag => tag.type === type);
                }

                const options = toTagOptions(rows);

                const totalRecords = getTotalRecords(response);
                const hasMore =
                    typeof totalRecords === 'number'
                        ? page * pageSize < totalRecords
                        : options.length === pageSize;

                return { options, hasMore };
            } catch (error) {
                console.error('Error', error);
                toast.error('Failed to fetch Tags.', {
                    description: 'Please try again.',
                });
                return { options: [], hasMore: false };
            }
        },
        [defaultPageSize, type]
    );

    return loadOptions;
};

export { useTagOptions };
